'use client'

import { useAppearanceStore } from '@/store/appearance';
import { ViewEnum } from '@/types';
import { useAuthToken } from '@/store/auth';
import dynamic from 'next/dynamic';
import { useGetSiteConfigs, useGetSiteConfigsWithSession } from '@/hooks/query/use-site-configs';
import { siteService } from '@/services/site.service';
import { LicenseeTypeEnums, SwitchFromEnum } from '@nf/types/site';
const RevisionNoticeModal = dynamic(() => import('./revision-notice-modal').then(m => m.RevisionNoticeModal));

/** Mars 改版通知 */
export const RevisionNotice = () => {
	const authToken = useAuthToken();
	const isBefore = !Boolean(authToken);
	const view = useAppearanceStore(state => state.view);
	const { SiteConfigsData } = useGetSiteConfigs();
	const { SiteConfigsWithSessionData } = useGetSiteConfigsWithSession();
	const platform = SiteConfigsWithSessionData?.SwitchFrom;

	// 限定 athena mobile user 可見
	const isEnable = !isBefore
		&& view === ViewEnum.mars
		&& SiteConfigsData?.EnableMarsRevisionNotice
		&& siteService.getLicenseeType() === LicenseeTypeEnums.Athena
		&& platform !== SwitchFromEnum.Desktop;

	return isEnable ? <RevisionNoticeModal /> : null;
};
